import dayJs from 'dayjs'
import { ActivityTopic } from './ActivityTopic'
import renderBodyWithLinks from './renderBodyWithLinks'
import './ActivityCard.scoped.scss'

const Badge = ({ badge }) => {
  const badgeClass = badge.type === 'failed' ? 'badge badge-failed' : 'badge badge-success'

  return (
    <span className={badgeClass}>
      {badge.type === 'opened' && <SvgIconsEye className="badge-icon" />}
      {badge.type === 'clicked' && <SvgIconsClick className="badge-icon" />}
      {badge.label}
      {badge.reason && <span className="badge-reason">{badge.reason}</span>}
    </span>
  )
}

const ActivityCard = ({ activity }) => {
  const linkableEntities = activity.activityEntities.filter(
    (entity) => entity.externalUrl
  )

  const bodyNodes = renderBodyWithLinks(activity.body, linkableEntities)

  const badges = activity.badges || []

  return (
    <div className="activity-log-item">
      <div className="icon small circle">
        {activity.topic === 'call' && <SvgIconsActivityLogCall />}
        {activity.topic === 'sms-blast' && <SvgIconsActivityLogSms />}
        {activity.topic === 'sms-survey' && <SvgIconsActivityLogSms />}
        {activity.topic === 'sms-conversation' && <SvgIconsActivityLogSms />}
        {activity.topic === 'email-blast' && <SvgIconsActivityLogEmail />}
        {activity.topic === 'zoom' && <SvgIconsActivityLogCall />}
        {activity.topic === 'webinar' && <SvgIconsActivityLogCall />}
        {activity.topic === 'flow' && <SvgIconsActivityLogPages />}
        {activity.topic === 'added' && <SvgIconsActivityLogImported />}
        {activity.topic === 'goal' && <SvgIconsBookmarkStar />}
      </div>

      <div className="purple-60 margin-left half" style={{ minWidth: '65px' }}>
        {dayJs(activity.createdAt).format('h:mm a')}
      </div>
      <div className="topic margin-left">
        <ActivityTopic topic={activity.topic} />
      </div>
      <div className="body">
        <p className="purple-60 smaller body-margins">{bodyNodes}</p>
      </div>
      {badges.length > 0 && (
        <div className="badges">
          {badges.map((badge, index) => (
            <Badge key={index} badge={badge} />
          ))}
        </div>
      )}
    </div>
  )
}

export default ActivityCard
